import {
  HistoryStack,
  HistoryStackEntry,
  HistoryStackLastAction,
} from '../../state';

export const createGetLastHistoryStackActionSelector = <S>(
  getHistoryStackState: (state: S) => HistoryStack,
): ((state: S) => HistoryStackLastAction | null) => (
  state: S,
): HistoryStackLastAction | null => getHistoryStackState(state).lastAction;
